// extracted by mini-css-extract-plugin
export var button = "index-module--button--123d2";
export var coins = "index-module--coins--64405";
export var content = "index-module--content--5cd40";
export var icon = "index-module--icon--a68ba";
export var inner = "index-module--inner--7f165";
export var item = "index-module--item--27436";
export var itemButton = "index-module--itemButton--6b4c8";
export var label = "index-module--label--da576";
export var network = "index-module--network--ee090";
export var title = "index-module--title--cfab5";